@let selectedWidget = selectedWidget$ | async;
@let savingWidget = savingWidget$ | async;
@let addElementLoaded = addElementLoaded$ | async;

@if (previewMode == false) {
  <!--presenter-elements-menu (left menu)-->
  <gb-presenter-elements-sidebar>
    @if (elementsSidebarHeaderSlot) {
      <div header>
        <ng-content select="[gbPresenterElementsSidebarHeader]"></ng-content>
      </div>
    } @else {
      <gb-presenter-sidebar-header header (updateProjectorContainerName)="onUpdateProjectorContainerName($event)">
        <gb-presenter-save-status [loaded$]="loadedStatus$"> </gb-presenter-save-status>
      </gb-presenter-sidebar-header>
    }

    <mat-tab-group list mat-stretch-tabs="true" animationDuration="0ms">
      <mat-tab [label]="'PRESENTER.ADD_ELEMENTS' | translate">
        <gb-presenter-elements-list
          (toggleCustomCss)="toggleCustomCss()"
          (addElement)="addWidget($event)"
          (openTemplatesDialog)="openTemplatesDialog()"
          [templateMode]="isTemplateMode"
          [addElementLoaded]="addElementLoaded"
          list
        ></gb-presenter-elements-list>
      </mat-tab>
      <mat-tab [label]="'PRESENTER.LAYERS' | translate">
        <gb-presenter-layers
          [layers]="layers$ | async"
          [selectedWidget]="selectedWidget"
          [backgroundColor]="backgroundColor"
          [backgroundImage]="backgroundImageUrl$ | async"
          (selectLayer)="onSelectLayer($event)"
          (selectBackground)="onSelectBackground()"
          (reorderLayers)="onReorderLayers($event)"
          (bringToFront)="onBringToFront()"
          (bringForward)="onBringForward()"
          (sendBackward)="onSendBackward()"
          (sendToBack)="onSendToBack()"
        ></gb-presenter-layers>
      </mat-tab>
    </mat-tab-group>

    <div class="presenter-edit-container">
      <div class="presenter-edit-content-container" #presenterContentContainer>
        @if (projectorContainerDataIsReady$ | async) {
          <gb-presenter-canvas
            [backgroundColor]="backgroundColor"
            [backgroundImage]="backgroundImageUrl$ | async"
            [backgroundImageCover]="backgroundImageCover$ | async"
            [customCss]="customCss"
            [draggable]="true"
            [responsive]="false"
            [selectedWidget]="selectedWidget"
            [savingWidget]="savingWidget"
            [selectedWidgetOverrides]="getSelectedWidgetOverrides()"
            (deselectWidget)="clearSelectedWidget()"
            (widgetSelected)="onCanvasWidgetSelected($event)"
            (widgetPositionChanged)="updateWidgetPosition($event)"
            (textWidgetCommitted)="onTextWidgetCommitted($event)"
            (textWidgetEditFinished)="onTextWidgetEditFinished($event)"
            (elementDropped)="onElementDropped($event)"
            [testData]="!!useTestDataControl.value"
            [inPreviewMode]="previewMode"
            [zoomLevel]="zoomLevel"
            [style.max-height]="canvasMaxHeight"
            (openRaffleItemWarning)="openRaffleItemWarning($event)"
          >
          </gb-presenter-canvas>

          @if (bottomToolbarSlot) {
            <ng-content select="[gbPresenterBottomToolbar]"></ng-content>
          } @else {
            <div class="bottom-toolbar-container">
              <div class="edit-slides-container">
                <gb-presenter-slides
                  [slides]="slides$ | async"
                  [currentSlideId]="selectedProjectorUuid$ | async"
                  (slideSelected)="onSlideSelected($event)"
                  (slideAdded)="onSlideAdded()"
                  (slideDeleted)="onSlideDeleted($event)"
                  (slideRenamed)="onSlideRenamed($event)"
                  (slideDuplicated)="onSlideDuplicated($event)"
                  (slideReordered)="onSlideReordered($event)"
                ></gb-presenter-slides>
              </div>
            </div>
          }

          @if (displayCustomCss) {
            <div class="custom-css-container">
              <div class="custom-css-resize-handle" (mousedown)="onCustomCssResizeMouseDown($event)"></div>
              <button class="close-css-button" mat-icon-button (click)="toggleCustomCss()">
                <gb-icon height="20px" icon="close"></gb-icon>
              </button>
              <gb-presenter-custom-css [customCssControl]="customCssControl"></gb-presenter-custom-css>
            </div>
          }
        }
        @if ((projectorContainerDataIsReady$ | async) === false) {
          <div class="spinner-container">
            <mat-spinner [diameter]="50"></mat-spinner>
          </div>
        }
      </div>

      <!--presenter-config-menu (right menu)-->
      <gb-presenter-config-sidebar>
        <div header>
          @if (isTemplateMode && configSidebarHeaderSlot) {
            <ng-content select="[gbPresenterConfigSidebarHeader]"></ng-content>
          } @else {
            <gb-presenter-preview (preview)="activatePreview(); clearSelectedWidget()"></gb-presenter-preview>
          }
        </div>
        <mat-slide-toggle [formControl]="useTestDataControl">
          {{ 'PRESENTER.USE_TEST_DATA' | translate }}
        </mat-slide-toggle>
        <div class="divider"></div>
        @if (isTemplateMode && !selectedWidget) {
          <gb-presenter-test-theme></gb-presenter-test-theme>
          <div class="divider"></div>
        }
        @if (configSidebarExtraSlot) {
          <ng-content select="[gbPresenterConfigSidebarExtra]"></ng-content>
        }

        @if (showCanvasTools$ | async) {
          <gb-presenter-tools-canvas
            [backgroundColorFormControl]="backgroundColorFormControl"
            [backgroundImages]="backgroundImages$ | async"
            [backgroundImageCover]="backgroundImageCover$ | async"
            [fontFamilyFormControl]="fontFamilyFormControl"
            (backgroundColorChange)="updateSlideColor($event)"
            (openBackgroundImageUploadDialog)="openBackgroundImageUploadDialog()"
            (clearBackgroundImage)="clearSlideBackgroundImage()"
            (backgroundImageCoverChange)="updateSlideBackgroundImageCover($event)"
            (fontFamilyChange)="updateSlideFontOverride('font_family', $event, fontFamilyFormControl)"
          >
          </gb-presenter-tools-canvas>
        }

        <gb-presenter-tools
          (previewWidget)="onPreviewWidget($event)"
          (resetPreviewWidget)="onResetPreviewWidget($event)"
          (previewNotification)="onPreviewNotification($event)"
          (alignLeft)="onAlignLeft()"
          (alignRight)="onAlignRight()"
          (alignTop)="onAlignTop()"
          (alignBottom)="onAlignBottom()"
          (alignHorizontalCenter)="onAlignHorizontalCenter()"
          (alignVerticalCenter)="onAlignVerticalCenter()"
          (bringToFront)="onBringToFront()"
          (bringForward)="onBringForward()"
          (sendBackward)="onSendBackward()"
          (sendToBack)="onSendToBack()"
          [isTemplateMode]="isTemplateMode"
        ></gb-presenter-tools>

        <div footer>
          @if ((widgetLoaded$ | async) === false) {
            <mat-progress-bar class="progress-bar" mode="indeterminate"></mat-progress-bar>
          }

          <gb-presenter-view-options
            [zoomLevel]="zoomLevel"
            (zoomChange)="setZoom($event)"
            (zoomToFitChange)="zoomToFit()"
            (zoomToFillChange)="zoomToFill()"
          ></gb-presenter-view-options>
          <gb-presenter-tools-general
            [canUndo]="(canUndo$ | async) ?? false"
            [canRedo]="(canRedo$ | async) ?? false"
            (undo)="onUndo()"
            (redo)="onRedo()"
            (copy)="onCopy()"
            (paste)="onPaste()"
            (delete)="deleteSelectedWidget()"
          ></gb-presenter-tools-general>
        </div>
      </gb-presenter-config-sidebar>
    </div>
  </gb-presenter-elements-sidebar>
} @else {
  <gb-presenter-view [previewMode]="true" (click)="disablePreview()"></gb-presenter-view>
}
